import { Link } from "react-router-dom";

export default function Navbar() {
  return (
    <nav className="flex justify-between px-8 py-4 bg-dark/80 backdrop-blur-md fixed w-full z-50">
      <h1 className="text-pinky text-2xl font-bold">VivtorCraft Server</h1>
      <div className="space-x-6">
        <Link to="/" className="hover:text-pinky transition">Home</Link>
        <Link to="/members" className="hover:text-pinky transition">Members</Link>
      </div>
    </nav>
  );
}